import React__default from "react";
import { useMergeRefs } from "@floating-ui/react";
import { ClickAreaContext } from "./click-area-context.mjs";
const ClickAreaTrigger = React__default.forwardRef(function ClickAreaTrigger2({ children, onClick, ...rest }, propRef) {
  const { setTrigger } = React__default.useContext(ClickAreaContext);
  const childRef = children.ref;
  const ref = useMergeRefs([setTrigger, propRef, childRef]);
  return React__default.isValidElement(children) ? React__default.cloneElement(children, {
    className: ["click-area__trigger", children.props.className].filter(Boolean).join(" "),
    ref,
    onClick: (event) => {
      var _a, _b;
      onClick == null ? void 0 : onClick(event);
      (_b = (_a = children.props).onClick) == null ? void 0 : _b.call(_a, event);
    },
    ...rest
  }) : (
    /* istanbul ignore next */
    null
  );
});
export {
  ClickAreaTrigger
};
